import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

// POST /api/v1/me/resend-verification-email. Auth required (ky's interceptor
// attaches the Bearer token automatically). Backend rate-limits to 1 request
// per minute per user via the verify-resend policy; a 429 surfaces as a
// failed mutation that the banner UI can render as "Try again in a minute".
export function useResendVerificationEmail() {
  return useMutation<void, Error, void>({
    mutationFn: async () => {
      await apiClient.post('api/v1/me/resend-verification-email');
    },
  });
}
